export enum BetonOrderConfirmErrorReasons {
  ValidationCalculationTotalPriceException = 'ValidationCalculationTotalPriceException',
}
